import React from 'react';
import { Button } from 'react-bootstrap';

const apiBase = '/v1';

const isImage = filename => (filename || '').match(/.(jpg|jpeg|png|gif)$/i);

const FileDetail = (
  { activeFile, onClose, isBrowsing, handleAddFile, onDeleteFile }
) => {
  const { name, file } = activeFile;

  return (
    <div>
      <div className="form">
        <span onClick={onClose} style={{ float: 'right' }}>
          <span className="ti ti-close" />
        </span>
        <h4>{name}</h4>
        <table className="table table-files">
          <tr>
            <th>Filename:</th>
            <td>{name}</td>
          </tr>
          <tr>
            <th>Directory:</th>
            <td>{`/${activeFile.getDirectory()}`}</td>
          </tr>
          <tr>
            <th>Size:</th>
            <td>{activeFile.getSize()}</td>
          </tr>
          {isImage(activeFile.getFullName()) &&
            <tr>
              <th>Preview:</th>
              <td>
                <img
                  src={
                    `${apiBase}/files/${encodeURIComponent(activeFile.getFullName())}`
                  }
                />
              </td>
            </tr>}
        </table>
        <div className="text-right">

          {isBrowsing &&
            <Button
              type="button"
              bsStyle="success"
              bsSize="sm"
              onClick={() => handleAddFile(activeFile)}
            >
              <span className="ti ti-plus" /> Add
            </Button>}
          {' '}
          {!isBrowsing &&
            <Button
              bsSize="sm"
              bsStyle="hollow-danger"
              onClick={() => onDeleteFile(activeFile)}
            >
              <span className="ti ti-trash" /> Delete
            </Button>}
          {' '}
          <Button
            bsSize="sm"
            bsStyle="hollow-info"
            href={
              `${apiBase}/files/${encodeURIComponent(activeFile.getFullName())}`
            }
          >
            <span className="ti ti-download" /> Download
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FileDetail;



// WEBPACK FOOTER //
// ./src/components/routes/files/FileDetail.js